import { BASE_URL, BASE_URL_DEV } from "../_constants/urlConstants";
const { buildErrResponse } = require("../_utils/utils");
const { default: Axios } = require("axios");

export const CashCardService = {
  getAllCashCard,
  getCashCardById,
  createCashCardBulk,
  updateCashCard,
  updateAvailableStatus,
  updateDiscountCashCardBulk,
  deleteCashCardById,
};

function getAllCashCard() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/cash-card`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getCashCardById(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/cash-card/id?id=${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function createCashCardBulk(body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/cash-card/bulk`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateCashCard(body, id) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/cash-card?id=${id}`, body)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateAvailableStatus(cashCardArray) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/cash-card/available-status`, cashCardArray)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateDiscountCashCardBulk(cashCardArray, discount) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/cash-card/bulk-discount`, cashCardArray, {
      params: {
        discount,
      },
    })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function deleteCashCardById(id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`${BASE_URL_DEV}/cash-card/id?id=${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
